var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgError(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.28 26.86L17.51 3A2 2 0 0014 3L.27 26.86a2 2 0 001.73 3h27.55a2 2 0 001.73-3zm-15.5-1.3a1.5 1.5 0 110-3 1.5 1.5 0 010 3zm1.5-6.16a1.5 1.5 0 11-3 0v-7a1.5 1.5 0 113 0v7z"
  })));
}

export default SvgError;